export default {
  views: {
    subGroups: {
      assign: "Assign subgroups",
      tagManager: "Tag manager: Choose your group",
      successAssign: "Amazing! You've updated the Sub Groups for your group.",

      errors: {
        assign: "Uh oh! Cannot assign a subgroup"
      },

      table: {
        firstName: "First name",
        lastName: "Last name",
        username: "Username",
        subGroup: "Subgroup"
      }
    },

    classes: {
      label: "Group",

      editGroup: "Edit group - Step ",
      addGroup: "Add group - Step ",
      classesCount: "{count} groups",

      errors: {
        group: "Failed to load group data.",
        update: "Failed to update group. Try again later",
        create: "Failed to create a group",
        emptyList: "You don’t have any groups in the selected school yet."
      },

      messages: {
        create: "A group has been created successfully!"
      }
    },

    schools: {
      label: "School",

      errors: {
        emptyList: "You don’t have any schools available.",
        fetchError: "Failed to fetch schools"
      }
    },

    teachers: {
      teachersCount: "{count} teachers",

      errors: {
        emptyList: "You don’t have any teachers yet.",
        details: " Failed to fetch teacher data."
      },

      titles: {
        edit: "Edit teacher"
      },

      messages: {
        create: "A teacher has been created successfully!",
        update: "A teacher has been updated!"
      }
    },

    grammarToGo: {
      title: "Grammar to Go"
    },

    home: {
      wantToAssign: "I want to assign a lesson",
      whatStudentsDo: "What are your students doing in Little Bridge?",
      howManyCountries: "How many countries do your students have DigiPals in?",
      numActivities: "How many activities have your students done?",
      numFriends: "How many DigiPals do your students have?",
      numMessages: "How many messages have your students sent?",

      errors: {
        dashboard: "Failed to fetch dashboard data."
      }
    },

    knowledgeBase: {
      title: "Knowledge Base",

      errors: {
        fetch: "Failed to fetch knowledge base",
        details: "Failed to fetch the knowledge base detail"
      }
    },

    lessons: {
      label: "Lesson",

      subgroups: "Sub Groups",

      messages: {
        setLessonsAuto:
          "Little Bridge will now set lessons for your students automatically. They will progress through the lessons at their own pace. You can override this anytime by assigning a lesson to your students."
      },

      hasBeenAssigned: "This lesson has been assigned.",
      assignAnother: "Assign another lesson",
      assignMyself: "I want to assign lessons myself",
      assignAuto: "I want Little Bridge to assign lessons automatically",
      lessonId: "Lesson {lessonId}",
      set: "Set lesson",
      activity: "Activity",
      resources: "Resources",

      statuses: {
        selected: "Lesson selected",
        archived: "Archived",
        current: "Current lesson",
        unassigned: "Unassigned"
      },

      stepper: {
        titles: {
          step1: "Step 1 - Who do you want to assign a lesson to?",
          step2: "Step 2 - Choose a lesson",
          step3: "Step 3 - Confirm"
        }
      },

      errors: {
        fetch: "Failed to fetch lessons."
      }
    },

    reports: {
      title: "Report Generator",
      type: "Report type",
      generate: "Generate report",

      level: "Level report",
      lesson: "Lesson report",
      test: "Checkpoint report",
      diagnostic: "Diagnostic report",
      baseline: "Start Line report",
      progress: "Progress test",
      students: "students",

      download: {
        pdf: "Download as PDF",
        csv: "Download as CSV",
        lessonPlan: "Download lesson plan PDF"
      },

      errors: {
        generate: "Failed to generate a report. Please try again later."
      }
    },

    students: {
      label: "Students",
      editStudent: "Edit Student",
      stundentsCount: "{count} students",
      add: "Add student",
      saveAndDownload: "Save and download students list",
      download: "Download students list",

      import: {
        step: "Import students - step ",
        clickVideo: "Click here to watch a short tutorial video",
        copyPasteFirst:
          "Please copy and paste the first names of your students into the ‘First Name’ text box.",
        copyPasteLast:
          "Please copy and paste the last names of your students in to the ‘Last Name’ text box.",
        confirm:
          "Great! Now let’s check that everything is correct. You can go back if you want to make any changes. Please check: both names of each student are correctly matched.",
        thoseStudentsAdded:
          "These students have been added to your account.For security reasons, you will not be able to download the passwords again, please ensure you save the file provided in a secure location on your computer.If the file did not auto download, please click on the ‘download student list' button now.",
        note: "Note - there is a 100 student limit per import."
      },

      messages: {
        create: "A student has been created successfully!",
        update: "A student has been updated!"
      },

      errors: {
        emptyList: "You don’t have any students yet.",
        details: "Failed to fetch student data.",
        import:
          "Uh oh! Something has gone wrong. Can you try copying and pasting the names again?",
        importPaste: "Uh oh! You haven’t pasted anything into column."
      }
    }
  },

  stepsLabels: {
    step4: "Step 4 - Confirm"
  },

  common: {
    next: "Next",
    ok: "OK",
    unassigned: "Unassigned",
    close: "Close",
    nextConfirm: "Next step - confirm",
    continue: "Continue",
    returnHome: "Return to homepage",
    finish: "Finish",
    confirm: "Confirm",
    save: "Save",
    siteUsage: "Site usage",
    reset: "Reset"
  },

  errors: {
    basic: "Failed to load data.",
    unexpected: "Unexpected error happend.",
    admin:
      "Oops! You are not authorised to do this. Please contact the account administrator."
  },

  tables: {
    lessons: {
      level: "Level",
      topic: "Topic",
      lesson: "Lesson",
      summary: "Summary",
      content: "Content",
      status: "Status",
      testCategory: "Test Category"
    },

    reports: {
      firstName: "First name",
      lastName: "Last name",
      username: "Username",
      lesson: "Lesson",
      topic: "Topic",
      scoreForActivity: "Score - {activityId}",
      correct: "Correct",
      progress: "Progress",
      levelNumber: "Level",
      lessonName: "Lesson name",
      activity1: "Activity 1",
      activity2: "Activity 2",
      activity3: "Activity 3",
      activity4: "Activity 4"
    },

    classes: {
      group: "Group",
      subgroup: "Sub Group",
      teacher: "Teacher",
      numberOfStudents: "Number of students",
      lesson: "Current lesson",

      errors: {
        failedDelete: "Failed to delete group(s). Try again later.",
        canBeAssign:
          "Students can only be assigned to one group at a time. Any students assigned to this group will be removed from their current group."
      }
    }
  },

  components: {
    noActivitiesInLesson: "No activities available in this lesson.",
    selectAll: "Select all",
    groupName: "Group name",
    assignStudents: "Next step - assign students",
    assignTeachers: "Next step - assign teachers",
    noData: "No data available.",
    videoSupport: "Sorry, your browser doesn't support embedded videos.",
    generateUsername: "Generate new username",
    password: "Password",
    admin: "Admin",
    view: "View",
    goBack: "Go back",
    openLanguageMenu: "Open language menu",
    isAdmin: "Is admin",
    selectALevel: "Select a level",

    warnings: {
      deleteClasses: "You are about to delete classes {clasessNames}"
    },

    errors: {
      selectGroups: "Select groups first.",
      editOneGroupAtOnce: "You can edit only 1 group at once",

      selectStudents: "Select students first.",
      deleteStudents: "You are about to delete students ",
      editOneStudentAtOnce: "You can edit only 1 student at once",
      failedToDeleteStudents: "Failed to delete students(s). Try again later.",
      selectTeachers: "Select the teachers first.",
      deleteTeachers: "You are about to delete teachers ",
      editOneTeacherAtOnce: "You can edit only 1 teacher at once",
      failedToDeleteTeachers: "Failed to delete teacher(s). Try again later.",
      teacherNames: "Please fill teacher's first and last names.",
      failedUsername: "The user name generation has failed. Try again later.",
      teacherEdit: "Unable to edit teacher's username"
    }
  },

  navigation: {
    open: "Open menu",
    subgroups: "Assign Sub Groups",
    goToDashboard: "Go to teacher dashboard",
    teachers: "Teachers",
    students: "Students",
    lessons: "Lessons",
    groups: "Groups",
    reports: "Report Generator",
    grammar: "Grammar to Go",
    knowledge: "Knowledge base",
    logout: "Log out"
  }
};
